import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.update()
    this.interval = setInterval(() => this.update(), 60000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  update() {
    this.element.textContent = new Date().toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      weekday: "short",
      month: "short",
      day: "2-digit"
    })
  }
}
